/* eslint-disable no-magic-numbers */
import MapMyIndiaInit from "./map-my-india-init";

class MapMyIndia extends MapMyIndiaInit {
    constructor() {
        super();
        this._map = null;
    }

    initMap() {
        let instance = this._map;
        if (!instance) {
            instance = new (this.getMap())(...arguments);
        }
        this._map = instance;
        return this._map;
    }

    reInitMap() {
        const instance = new (this.getMap())(...arguments);
        this._map = instance;
        return this._map;
    }

    initMarker() {
        return new (this.getMarker())();
    }

    initInfoWindow() {
        // return new (this.getInfoWindow())(...arguments);
    }

    centerToPosition({
        marker,
        position,
        markerIcon,
        infoWindowContent,
        iconOverrides = {}
    }) {
        marker.setLatLng(position);
        const icon = new (this.getIcon())({
            iconUrl: markerIcon,
            iconSize: [38, 95],
            iconAnchor: [22, 94],
            popupAnchor: [-3, -76],
            shadowSize: [68, 95],
            shadowAnchor: [22, 94],
            ...iconOverrides
        });
        marker.setIcon(icon);
        marker.addTo(this._map);
        if (infoWindowContent) {
            marker.bindPopup(infoWindowContent);
        }
        window.setTimeout(() => {
            marker.openPopup();
        }, 100);
        this._map.panTo(position);
    }

    panTo({ lat, lng }) {
        this._map.setZoom(11);
        window.setTimeout(() => {
            this._map.panTo({ lat, lng });
        }, 400);
    }

    addCenterChangedListener(callback) {
        return this._map.on("dragend", () => {
            const center = this._map.getCenter();
            return callback({
                lat: center.lat,
                lng: center.lng
            });
        });
    }
}

export default MapMyIndia;
